/* eslint-disable no-console */
const IS_DEV = process.env.NODE_ENV === 'development';

const noop = () => {};

const logger = {
  error: IS_DEV ? console.error.bind(console) : noop,
  warn: IS_DEV ? console.warn.bind(console) : noop,
  info: IS_DEV ? console.info.bind(console) : noop,
};

export default logger;
